var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompensation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 22.8555C11.668 21.7509 12.5634 20.8555 13.668 20.8555L39.7863 20.8555C40.8909 20.8555 41.7863 21.7509 41.7863 22.8555V29.1384V51.9872C41.7863 53.0918 40.8909 53.9872 39.7863 53.9872H13.668C12.5634 53.9872 11.668 53.0918 11.668 51.9872V22.8555Z",
    fill: "#66AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5117 16C18.5117 14.8954 19.4071 14 20.5117 14L46.6301 14C47.7347 14 48.6301 14.8954 48.6301 16V24.0002V52.001C48.6301 53.1055 47.7347 54.001 46.6301 54.001H20.5117C19.4072 54.001 18.5117 53.1055 18.5117 52.001V16Z",
    fill: "#B3D7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6445,
    y: 32.666,
    width: 7.8681,
    height: 1.96703,
    rx: 0.983513,
    fill: "#66AFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6445,
    y: 42.1846,
    width: 7.8681,
    height: 1.96703,
    rx: 0.983513,
    fill: "#66AFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6445,
    y: 37.4258,
    width: 19.6703,
    height: 1.96703,
    rx: 0.983513,
    fill: "#66AFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6445,
    y: 20.8711,
    width: 13.7692,
    height: 1.96703,
    rx: 0.983513,
    fill: "#66AFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.6445,
    y: 25.6211,
    width: 19.6703,
    height: 1.96703,
    rx: 0.983513,
    fill: "#66AFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4803 28.6488L45.9308 21.9883L58.474 28.6488C58.474 28.6488 59.0474 34.837 56.395 41.3189C51.5312 53.2048 45.9308 53.989 45.9308 53.989C45.9308 53.989 39.9402 53.3297 35.4264 41.3189C32.7237 34.127 33.4803 28.6488 33.4803 28.6488Z",
    fill: "#3395FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2383 36.847C40.2383 36.2158 40.6472 35.7041 41.1515 35.7041H51.0957C51.6001 35.7041 52.009 36.2158 52.009 36.847C52.009 37.4782 51.6001 37.9899 51.0957 37.9899H41.1515C40.6472 37.9899 40.2383 37.4782 40.2383 36.847Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9509 31.1328C46.5821 31.1328 47.0937 31.5417 47.0937 32.0461L47.0937 41.9903C47.0937 42.4946 46.5821 42.9035 45.9509 42.9035C45.3197 42.9035 44.808 42.4946 44.808 41.9903L44.808 32.0461C44.808 31.5417 45.3197 31.1328 45.9509 31.1328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensation);
export default __webpack_public_path__ + "static/media/compensation.ed0e5399650d3ce0470c8c7b8b327f9f.svg";
export { ForwardRef as ReactComponent };